import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, environmentToken } from '@environment';
import {
  BLEKeyDeliveryProgressApiResponse,
  BLEKeyDeliveryRetryApiResponse,
  GatewayJoinStatusResponse,
  LatestOpenJoiningSessionStatus,
  OpenJoiningStatus
} from '@app/shared/models/nms.models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NmsResource {
  private readonly baseUrl: string;
  constructor(private httpClient: HttpClient, @Inject(environmentToken) private environment: Environment) {
    this.baseUrl = `${this.environment.apiUrl}${environment.apiPath}`;
  }

  isDeviceReadyForJoining(buildingId: number): Observable<OpenJoiningStatus> {
    return this.httpClient.get<OpenJoiningStatus>(`${this.baseUrl}/nms/building/${buildingId}/open-joining/readiness`);
  }

  startDeviceJoining(buildingId: number): Observable<string> {
    return this.httpClient.post(`${this.baseUrl}/nms/building/${buildingId}/open-joining/activate`, {}, {
      responseType: 'text'
    });
  }

  stopDeviceJoining(buildingId: number): Observable<string> {
    return this.httpClient.post(`${this.baseUrl}/nms/building/${buildingId}/open-joining/deactivate`, {}, {
      responseType: 'text'
    });
  }

  getLatestOpenJoiningSessionStatus(buildingId: number): Observable<LatestOpenJoiningSessionStatus> {
    return this.httpClient.get<LatestOpenJoiningSessionStatus>(
      `${this.baseUrl}/nms/building/${buildingId}/open-joining/status/latest`
    );
  }

  getCurrentGatewayStatuses(buildingId: number): Observable<GatewayJoinStatusResponse[]> {
    return this.httpClient.get<GatewayJoinStatusResponse[]>(
      `${this.baseUrl}/nms/building/${buildingId}/gateway-status`
    );
  }

  getSessionHistory(buildingId: number): Observable<LatestOpenJoiningSessionStatus[]> {
    return this.httpClient.get<LatestOpenJoiningSessionStatus[]>(
      `${this.baseUrl}/nms/building/${buildingId}/open-joining/session-history`
    );
  }

  loadBLEKeyDelivery(buildingId: number): Observable<BLEKeyDeliveryProgressApiResponse> {
    return this.httpClient.get<BLEKeyDeliveryProgressApiResponse>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/sessions/latest/progress`
    );
  }

  retryBLEKeyDelivery(buildingId: number, workflowId: number): Observable<BLEKeyDeliveryRetryApiResponse> {
    return this.httpClient.post<BLEKeyDeliveryRetryApiResponse>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/workflows/${workflowId}/retry`, {}
    );
  }
}
